import { pdf } from '@react-pdf/renderer';
import { db, withExtras, withFormulas, withParents } from './Dexie-Setup';
import { processAndSortItems } from './helpers';
import Ticket from '../../Components/elements/Ticket/Ticket';

// Helper function to convert blob to base64
const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result); // Return the full data URL
    };
    reader.readAsDataURL(blob);
  });
};

export const generateCompletePdfBase64 = async (reportRecord, tx) => {
  // 1. Ensure the report record itself is fully processed
  const processedReport = await withExtras("dailyFieldReports", [withParents, withFormulas], tx)([reportRecord]).then(res => res[0]);

  // 2. Fetch related items
  const [equipmentLineItems, laborLineItems, job] = await Promise.all([
    tx.equipmentLineItems.where('relatedDailyFieldReport').equals(processedReport.recordId).toArray(),
    tx.laborLineItems.where('relatedDailyFieldReport').equals(processedReport.recordId).toArray(),
    tx.jobs.where('jobNumber').equals(processedReport.jobNumber || "").first(),
  ]);

  // 3. Format and combine line items
  const formattedLabor = laborLineItems.map(item => ({
    ...item,
    type: "Labor",
    name: [item.position, item.earnCode, `${item.shift} Shift`, item.driver ? "Service Vehicle Used" : null].filter(Boolean).join(' - '),
    qty: item.hours,
    unit: "hrs",
  }));
  const combinedItems = [...formattedLabor, ...equipmentLineItems];
  const items = processAndSortItems(combinedItems);

  // 4. Assemble the complete ticketData object
  const ticketData = {
    ...processedReport,
    items,
    job: job || {},
  };

  // 5. Generate the PDF
  let blob;
  try {
    blob = await pdf(<Ticket data={ticketData} />).toBlob();
  } catch (pdfError) {
    console.error("Error generating PDF blob:", pdfError);
    throw pdfError; // Re-throw to ensure transaction rollback
  }
  let base64;
  try {
    base64 = await blobToBase64(blob);
  } catch (base64Error) {
    console.error("Error converting blob to base64:", base64Error);
    throw base64Error; // Re-throw to ensure transaction rollback
  }
  
  // 6. Return only the base64 content
  return base64.split(',')[1];
};
